import { render, staticRenderFns } from "./DocumentSectionsForm.vue?vue&type=template&id=3541bc50&"
import script from "./DocumentSectionsForm.vue?vue&type=script&lang=js&"
export * from "./DocumentSectionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports